/**
 * Application Routes Component
 *
 * Defines all application routes
 */

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useUserData } from "../hooks/useUserData";
import ScrollToTop from "../components/layout/ScrollToTop";
import HomePage from "./HomePage";
import { initializeProgressiveLoading } from "./progressiveLoaderConfig";
import { getHomeSuggestions } from "./routes/routeConfig";
import { getMagazineRoutes } from "./routes/magazineRoutes";
import { getBusinessRoutes } from "./routes/businessRoutes";
import { getUserRoutes } from "./routes/userRoutes";
import { getContentRoutes } from "./routes/contentRoutes";
import { getAuthRoutes } from "./routes/authRoutes";

const AppRoutes = () => {
  const { getProfileProps, getComponentProps, getHeaderStyleProps, userData } =
    useUserData();

  // Setup progressive loading after component mounts
  React.useEffect(() => {
    return initializeProgressiveLoading();
  }, []);

  const suggestions = getHomeSuggestions();
  const routeProps = {
    getProfileProps,
    getComponentProps,
    getHeaderStyleProps,
    userData,
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900">
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Home page route */}
          <Route path="/" element={<HomePage suggestions={suggestions} />} />

          {/* Magazine and news routes */}
          {getMagazineRoutes(routeProps)}

          {/* Content routes (products, services, about, careers) */}
          {getContentRoutes(routeProps)}

          {/* Business routes */}
          {getBusinessRoutes(routeProps)}

          {/* User account routes */}
          {getUserRoutes(routeProps)}

          {/* Authentication routes */}
          {getAuthRoutes()}

          {/* Fallback route for any unmatched paths */}
          <Route path="*" element={<HomePage suggestions={suggestions} />} />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
